import { Heart } from "lucide-react";

interface LoginProps {
  onLogin: () => void;
}

export default function Login({ onLogin }: LoginProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-6 sm:space-y-8">
        <div className="text-center">
          <Heart className="h-16 w-16 mx-auto mb-4 text-red-600" />
          <h2 className="text-3xl font-extrabold text-gray-900">mAlive</h2>
          <p className="mt-2 text-sm text-gray-600">
            Sign in to access your safety monitoring system
          </p>
        </div>

        <div className="mt-8 space-y-6">
          <div>
            <button
              onClick={onLogin}
              className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
            >
              Sign in with Auth0
            </button>
          </div>

          <div className="text-center">
            <p className="text-sm text-gray-600">Secure authentication powered by Auth0</p>
          </div>
        </div>
      </div>
    </div>
  );
}
